import { IState } from "@redux/store.types";
import { getValueState } from "@redux/utils";

import { $WishlistModalModuleName } from "./wishlistModal.types";

export const getWishlistModalVisible = (state: IState) =>
    getValueState(state, $WishlistModalModuleName)?.visible;

export const getWishlistModalProduct = (state: IState) =>
    getValueState(state, $WishlistModalModuleName)?.product;
